import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useCookies } from "react-cookie";
import { getCookie } from "../utils/service";
import RouteConstants from "../constants/routeConstants.json";

const NonAuthRouteProtection = (props) => {
  const location = useLocation();
  const cookie = getCookie(["x-access-token"]);
  let loadComponent = false;
  let route = RouteConstants.DASHBOARD;

  // Get page url
  const { pathname } = location;
  if (pathname === RouteConstants?.RESET_PASSWORD) {
    route = RouteConstants.RESET_PASSWORD;
  } else if (cookie) {
    loadComponent = true;
  } else {
    route = RouteConstants.DASHBOARD;
  }

  return (
    <>
      {loadComponent ? (
        <Navigate to={route} state={{ from: location }} replace />
      ) : (
        <Outlet />
      )}
    </>
  );
};

export default NonAuthRouteProtection;
